import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
    { label: '발생 가능 현황', to: '/guide/current' },
    { label: '현장 이해관계자', to: '/guide/stakeholder' },
    { label: '이해관계자 서명', to: '/guide/signature' },
    { label: '예방대책', to: '/guide/prevent' },
    { label: 'AI알리미', to: '/guide/ai' },
    { label: '명함', to: '/guide/biz' },
];

const PublicNav = ({ onLoginClick }) => {
    const location = useLocation();

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom py-3 shadow-sm"
            style={{ position: 'sticky', top: 0, zIndex: 1000 }}>
            <div className="container">
                <Link className="navbar-brand d-flex align-items-center" to="/">
                    <img src="/img/logo.png" alt="회사 로고" style={{ height: '30px', marginRight: '10px' }} />
                    <span className="fw-bold" style={{ color: '#333', fontSize: '1.1rem' }}>중대재해 예방 플랫폼</span>
                </Link>

                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#publicNavbar"
                    aria-controls="publicNavbar" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="publicNavbar">
                    <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                        {navLinks.map(link => (
                            <li className="nav-item" key={link.to}>
                                <Link
                                    className={`nav-link fw-bold px-3 ${location.pathname === link.to ? 'text-primary' : 'text-secondary'}`}
                                    style={location.pathname === link.to ? { borderBottom: '2px solid #0d6efd', paddingBottom: '0.25rem' } : {}}
                                    to={link.to}
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                    <div className="d-flex mt-3 mt-lg-0">
                        <button
                            className="btn btn-outline-primary fw-bold px-4"
                            style={{ borderRadius: '4px', whiteSpace: 'nowrap' }}
                            onClick={onLoginClick}
                        >
                            로그인
                        </button>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default PublicNav;
